import { Pipe, PipeTransform } from '@angular/core';
import { SessionSetting, Resources } from '../../app.service';

@Pipe({name: 'ps_i18n', pure: false})
export class PsI18nPipe implements PipeTransform {
    constructor() {}

    transform(value: any, args?: any): any {
        if (args) {
            return Resources.getLabel(value, args);
        }
        return Resources.getLabel(value);
    }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.core/i18n/psi18n.pipe.ts